export default __webpack_public_path__ + "static/icon-2-1-3b9d7063ca257c94e121c056b7b579c8.png";